import IconBase from "./IconBase";

const PadlockIcon = ({ noKeyhole = false, ...props }) => (
  <IconBase data-testid="PadlockIcon" {...props}>
    <g fill="none">
      <rect
        stroke="currentColor"
        strokeWidth="2"
        x="4"
        y="9"
        width="12"
        height="8"
        rx="3"
      />
      {!noKeyhole && (
        <circle fill="currentColor" fillRule="evenodd" cx="10" cy="13" r="1" />
      )}
      <path
        d="M6.5 9V5.5a3.5 3.5 0 0 1 7 0V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </IconBase>
);

export default PadlockIcon;
